const articles = {
  title: "文章资讯",
  subtitle: "浏览开云平台最新资讯与使用指南",
  readCount: "次阅读",
  publishedAt: "发布于",
  relatedArticles: "相关文章",
  tags: "标签",
  noArticles: "暂无文章",
};

export default articles;